const countFilters = (items) => {
  return items.reduce((acc, curr) => {
    const { items: itemRefinements } = curr
    return acc + (itemRefinements ? itemRefinements.length : 1)
  }, 0)
}

export default countFilters
